/* eslint-disable no-unneeded-ternary */
/* eslint-disable default-param-last */
import * as auth from '../constants/auth';

const initialState = {
  token: null,
  isAuthenticated: false,
  isLoading: false,
  user: null,
  apps: [],
  activeApp: null,
};

export default function authReducer(state = initialState, action) {
  switch (action.type) {
    case auth.USER_LOADING:
      return {
        ...state,
        isLoading: true,
      };
    case auth.USER_LOADED:
      return {
        ...state,
        ...action.payload,
        isLoading: false,
        isAuthenticated: true,
      };
    case auth.LOGIN_SUCCEED:
      localStorage.setItem('user_session', JSON.stringify(action.payload));
      return {
        ...state,
        ...action.payload,
        isLoading: false,
        isAuthenticated: true,
      };
    case auth.USER_LOGOUT:
      return {
        ...initialState,
      };
    case auth.SET_ACTIVE_APP:
      return {
        ...state,
        activeApp: action.payload,
      };
    case auth.AUTH_ERROR:
      return {
        ...initialState,
      };
    default:
      return state;
  }
}
